import WixSDK from 'shared/utils/wix-sdk';

import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import {
  normalizeArrayOfPaymentInfoVideos,
  normalizePaymentInfoChannel,
} from 'shared/redux/helpers/normalized';
import { getMemberInfo } from 'api/public/channel/channel';

const ACTIONS = createAsyncActions('SERVER.CHANNEL.PAYMENT');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;

export default function(id, options = {}) {
  return function(dispatch, getState) {
    const uid = WixSDK.Utils.getUid();

    if (!uid) {
      return Promise.resolve().then(() => dispatch(SUCCESS()));
    }

    const state = getState();

    const {
      channelVideos: { ids: items },
    } = state;
    options = {
      instance: WixSDK.Utils.getInstance(),
      ...options,
      items,
    };

    const params = { id, options };
    dispatch(START(params));

    return getMemberInfo(id, WixSDK.Utils.getInstance()).then(
      function(response) {
        const items = _.get(response, 'data.items', []);

        if (!items.length) {
          dispatch(SUCCESS(params, response));
          return response;
        }

        const [channelData, videoDataList] = _.partition(
          items,
          item => !item.itemId,
        );
        const channel = _.get(channelData, '[0]');
        const videos = _.map(videoDataList, video =>
          _.pick(video, 'dgsInfo', 'itemId', 'listId'),
        );

        let normalizeChannel = {};

        if (channel) {
          normalizeChannel = {
            ...normalizePaymentInfoChannel(
              _.pick(channel, 'dgsInfo', 'listId'),
            ),
          };
        }

        response = {
          ...response,
          data: _.merge(
            {},
            normalizeChannel,
            normalizeArrayOfPaymentInfoVideos(videos),
          ),
        };

        dispatch(SUCCESS(params, response));
        return response;
      },

      function(reason) {
        const meta = {
          analytics: { type: 'error', name: 'shared.channel.payment.get' },
        };

        if (_.isError(reason)) {
          dispatch(FAIL(reason, null, meta));
        } else {
          dispatch(FAIL(params, reason, meta));
        }

        return Promise.reject(reason);
      },
    );
  };
}
